import * as React from 'react';

import { CompanyLabel } from '../CompanyLabel';
import * as styles from './CianContacts.css';

export const CianContacts: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <div className={styles['container']}>
      <CompanyLabel>КОНСУЛЬТАНТ</CompanyLabel>
      <div className={styles['info']}>
        <strong className={styles['title']}>Циан</strong>
        <p className={styles['description']}>Основан в 2001 году</p>
      </div>
      {children}
    </div>
  );
};

CianContacts.displayName = 'CianContacts';
